import gql from 'graphql-tag';
export const StatFeatureStaffAttendancePage = gql `
    fragment StatFeatureStaffAttendancePage on StaffAttendancePageFeatureSettingsFlags {
        isEnabled
        canOptIn
    }
`;
